<template>
  <div class="flex flex-col mb-10 bg-white">
    <div class="hidden w-full sm:block bg-image" :style="bgStyle" />
    <div class="p-4 content-container sm:px-16 sm:py-6">
      <h1 class="mb-2 text-lg font-bold text-center md:text-3xl">{{ stepTitle }}</h1>
    </div>

    <readonly-banner v-if="readonly" class="mx-auto w-max" />
  </div>
</template>

<script>
export default {
  name: 'wizard-page-header',
  props: {
    stepTitle: String,
    readonly: Boolean
  },
  computed: {
    bgStyle() {
      return {
        backgroundImage: `url(${require('@/assets/bg.svg')})`
      };
    }
  }
};
</script>

<style lang="scss">
.bg-image {
  height: 50px;

  @media (min-width: 768px) {
    height: 100px;
  }
}
</style>
